










































































































import { Component, Vue } from 'vue-property-decorator';
import { MasterDriverModule } from '@/store/index';
import {
  FilterInput,
  FilterConditions,
  TransformFiltersToJson
} from '@/shared/services/filter/filter.service';
import { DriverType } from './driver-filter.model';
import { ToastHelper } from '@/utils/toast.util';
import Loading from '@/shared/components/Loading.vue';
import DIVFilter from '@/shared/components/filters/DIVFilter.vue';

@Component({
  components: {
    Loading,
    DIVFilter
  }
})
export default class DriverFilters extends Vue {
  masterDriverModule = MasterDriverModule;
  loading = false;
  positionOptions = [
    { value: null, text: this.$i18n.t('trackingStatus.ALL') },
    { value: 'Company', text: this.$i18n.t('mainTable.company') },
    { value: 'Owner', text: this.$i18n.t('mainTable.owner') },
    { value: 'Carrier', text: this.$i18n.t('mainTable.carrier') }
  ];
  statusOptions = [
    { value: null, text: this.$i18n.t('trackingStatus.ALL') },
    { value: true, text: this.$i18n.t('mainTable.active') },
    { value: false, text: this.$i18n.t('mainTable.inactive') }
  ];

  constructor() {
    super();
  }

  DIVFilter = new FilterInput({
    condition: FilterConditions.Equal,
    search: null,
    field: DriverType.DIV
  });

  PositionFilter = new FilterInput({
    condition: FilterConditions.Equal,
    search: null,
    field: DriverType.Position
  });

  StatusFilter = new FilterInput({
    condition: FilterConditions.Equal,
    search: true,
    field: DriverType.Status
  });

  NameFilter = new FilterInput({
    condition: FilterConditions.BeginsWith,
    search: null,
    field: DriverType.Name
  });

  created() {
    this.search();
  }

  async search() {
    this.loading = true;
    this.$emit('loading', this.loading);

    try {
      this.masterDriverModule.setFilters(
        TransformFiltersToJson([
          this.DIVFilter,
          this.PositionFilter,
          this.StatusFilter,
          this.NameFilter
        ])
      );
      await this.masterDriverModule.search();
    } catch (err) {
      ToastHelper.show('Driver search', err.message, 5000, 'danger');
    }

    this.loading = false;
    this.$emit('loading', this.loading);
  }

  resetFilters() {
    this.DIVFilter = new FilterInput({
      condition: FilterConditions.Equal,
      search: null,
      field: DriverType.DIV
    });

    this.PositionFilter = new FilterInput({
      condition: FilterConditions.Equal,
      search: null,
      field: DriverType.Position
    });

    this.StatusFilter = new FilterInput({
      condition: FilterConditions.Equal,
      search: true,
      field: DriverType.Status
    });

    this.NameFilter = new FilterInput({
      condition: FilterConditions.Equal,
      search: null,
      field: DriverType.Name
    });

    this.masterDriverModule.setFilters(
      TransformFiltersToJson([
        this.DIVFilter,
        this.PositionFilter,
        this.StatusFilter,
        this.NameFilter
      ])
    );
  }
}
